import { useEffect, useState } from 'react'
import { emitterProps, globalEmitter } from '../helpers/emitter'
import { type_GM_STATE } from '../../helpers'
import { openModal } from '../helpers/useModal'
import { HeartIcon } from '../icons/HeartIcon'
import debounce from 'lodash.debounce'

declare var GM_STATE: type_GM_STATE

const MOBILE_HEADER_BREAKPOINT: number = 1024

export function AccountHeader() {
  const { logged } = GM_STATE.customer
  const [isHasList, setIsHasList] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_HEADER_BREAKPOINT)

  const handleClick = () => {
    const rootUrlWithoutSlash = window.routes.rootUrlWithoutSlash

    if (logged) {
      window.location.href = rootUrlWithoutSlash + '/account?view=wishlist'
    } else {
      if (theme.pageType.includes('customers')) {
        const formSelectors = document.querySelectorAll('.js-form-account-custom')
        if (!formSelectors) {
          return
        }
        formSelectors.forEach(form => {
          const inputReturn = form.querySelector('input[name="return_to"]')
          if (inputReturn) {
            inputReturn.value = rootUrlWithoutSlash + '/account?view=wishlist'
          } else {
            const inputReturn = `<input type="hidden" name="return_to" value="${rootUrlWithoutSlash}/account?view=wishlist">`
            formSelectors.innerHTML += inputReturn
          }
        })
      } else {
        sessionStorage.setItem('returnTo', `/account?view=wishlist`)
        openModal('account-slideout')
      }
    }
  }

  const fetchWishlist = async () => {
    if (!window.omneoService) return []
    const wishlistLists = await window.omneoService.getLists()
    if (!wishlistLists) return []
    globalEmitter.emit('fetchWishlist', wishlistLists)
    sessionStorage.setItem('wishlistsGlobal', JSON.stringify(wishlistLists))

    if (wishlistLists.length > 0) {
      setTimeout(() => {
        setIsHasList(wishlistLists.some((item) => item.items.length > 0))
      }, 1000)
    }
  }

  useEffect(() => {
    fetchWishlist().then()
    globalEmitter.on(emitterProps.wishlist.add, fetchWishlist)
  }, [])

  useEffect(() => {
    globalEmitter.on(emitterProps.wishlist.remove, fetchWishlist)
  }, [])

  useEffect(() => {
    window.addEventListener(
      'resize',
      debounce(() => {
        setIsMobile(window.innerWidth < MOBILE_HEADER_BREAKPOINT)
      }),
      100
    )
  }, [])

  return (
    <div className='mega-menu__wishlist' tabIndex={0} onClick={handleClick}>
      {isMobile ? (
        <HeartIcon className={`Icon ${isHasList ? 'Icon__WishList' : ''}`} />
      ) : (
        'Wishlist'
      )}
      {!isMobile && <div className={`mega-menu__dot js-wishlist-dot${!isHasList ? ' hidden' : ''}`}></div>}
    </div>
  )
}
